/**
 * Block 14 «Раскрой» — PR #2-UI. Горизонтальный TabBar (ADR-0063, исключение
 * P-019 для навигации вкладок Раскроя — «точно как прототип», §IX.X #4).
 *
 * 6 вкладок, SVG-иконки вербатим из `project.html` (см. `cuttingTabs.tsx`).
 * Используется на `/cutting` (disabled) и `/cutting/project` (активный).
 */

import { CUTTING_TABS, type CuttingTabId } from './cuttingTabs';

interface CuttingTabBarProps {
  /** Активная вкладка (на `/cutting/project`). */
  activeTab?: CuttingTabId;
  /** Колбэк выбора вкладки. Если не задан — вкладки disabled (экран `/cutting`). */
  onSelect?: (id: CuttingTabId) => void;
}

export function CuttingTabBar({ activeTab, onSelect }: CuttingTabBarProps) {
  const disabled = !onSelect;
  return (
    <nav className="sc-tabbar" id="tabbar" aria-label="Вкладки раскроя">
      {CUTTING_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`sc-tab${tab.id === activeTab ? ' active' : ''}`}
          data-tab={tab.id}
          disabled={disabled}
          aria-current={tab.id === activeTab ? 'page' : undefined}
          onClick={onSelect ? () => onSelect(tab.id) : undefined}
        >
          <div className="sc-tab-icon-box">{tab.icon}</div>
          <span className="sc-tab-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
